import {
    Center,
    Divider,
    HStack,
    Spinner,
    Stack,
    Text,
    useToken,
} from '@chakra-ui/react';
import CardContainer from 'components/CardContainer';
import CustomPagination from 'components/CustomPagination';
import { useColorModeValueKey } from 'hooks/useColors';
import React, { useState } from 'react';
import tinycolor from 'tinycolor2';
import { formatDateTime } from 'utils/formator';
import { useClientInteractions, useInteractions } from 'hooks/datahook/adminClients';
import CustomDialog from './CustomDialog';
import { useTranslation } from 'react-i18next';
import { useAdminProfile, useProfile } from 'hooks/datahook/auth';
import { useAuth } from 'hooks/useAuth';

const InteractionItem = (props) => {
    const { item } = props;
    const { type, createByName, message, createdAt, id } = item;
    const grayColor = useColorModeValueKey('gray');
    const bgColor = useColorModeValueKey('bg');
    const hoverColor = tinycolor(useToken('colors', bgColor))
        .setAlpha(0.4)
        .toRgbString();
    const { t } = useTranslation('app');
    const messageArr = message.split(',');

    return (
        <Stack
            px={4}
            py={3}
            pl={3}
            spacing={2}
            transition={'all 0.2s linear'}
            _hover={{
                backgroundColor: hoverColor,
            }}
            cursor={'pointer'}
        >
            <Stack spacing={1}>
                <HStack>
                    <Text
                        fontSize={'sm'}
                        noOfLines={2}
                        flex={1}
                        fontWeight={'500'}
                    >
                        {t(type)}
                    </Text>
                </HStack>
                <HStack>
                    <Text fontSize={'2xs'} color={grayColor}>
                        {formatDateTime(createdAt)}
                    </Text>
                    {createByName && (
                        <Text fontSize={'2xs'} color={grayColor}>
                            {/* {t('operatoredBy')} {createByName} */}
                            {createByName}
                        </Text>
                    )}
                </HStack>
            </Stack>
            <Stack rounded={'md'} bg={bgColor} px={2} py={1}>
                <Text fontSize={'xs'}>
                    {type === 'Login'
                        ? messageArr[2] === ' Region: undefined:undefined'
                        ? messageArr.splice(0, 2).join(', ')
                        : messageArr.splice(0, 3).join(', ')
                        : message}
                </Text>
            </Stack>
        </Stack>
    );
};

const ClientInteractions = (props) => {
    const { id } = props;
    const { t } = useTranslation('app');
    const { isUser } = useAuth();
    const {
        data,
        isLoading,
        totalPage,
        size,
        page,
        setPage,
        totalItems,
        pageSize,
    } = (isUser ? useInteractions : useClientInteractions)({ user: id, type: "Login" });
    const grayColor = useColorModeValueKey('gray');

    return (
        <Stack spacing={4}>
            <CardContainer noPaddingContent mb={4} shadow={'none'}>
                {isLoading ? (
                    <Center py={6} flex={1} height="100%" width={'100%'}>
                        <HStack alignItems="center">
                            <Spinner />
                            <Text fontSize="lg">{t('loading')}...</Text>
                        </HStack>
                    </Center>
                ) : data?.length ? (
                    <Stack spacing={1} divider={<Divider />} h={'80vh'} overflowY={'auto'}>
                        {(data || []).map((item) => (
                            <InteractionItem key={item.id} item={item} />
                        ))}
                    </Stack>
                ) : (
                    <Center py={6} flex={1} height="100%" width={'100%'}>
                        <Text color={grayColor}>{t('noInteractions')}</Text>
                    </Center>
                )}
                <Divider />
                <HStack
                    alignItems={'center'}
                    justifyContent={'flex-end'}
                    px={4}
                    py={3}
                >
                    <CustomPagination
                        totalPage={totalPage}
                        page={page}
                        onChange={(p) => {
                            setPage(p);
                        }}
                        pageSize={pageSize}
                        totalItems={totalItems}
                    />
                </HStack>
            </CardContainer>
        </Stack>
    );
};

const InteractionsDialog = (props) => {
    const { t } = useTranslation('app');
    const { open, onClose } = props;
    const { isUser } = useAuth();
    const { data: profile } = (isUser ? useProfile : useAdminProfile)();
    return (
        <CustomDialog
            size="lg"
            open={open}
            onClose={onClose}
            title={t('loginHistory')}
        >
            <ClientInteractions id={profile?.id} />
        </CustomDialog>
    );
};

export default InteractionsDialog;